/**
 * @author Kelnik
 *
 * StartSection - Первый экран (анимация)
 */

import {TimelineLite} from 'gsap';

class StartSection {
    constructor() {
        this.container = document.querySelector('.j-start-section');
        this.header = document.querySelector('.b-header-wrap_with_animate');
        this.loader = this.container.querySelector('.j-start-section-loader');

        this.mainObject = document.querySelector('.main-object');

        this.delayAnimate = 1000;
        this.durationAnimate = 0.3;
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initTweenLite();
        this._bindEvents();
    }

    _initTweenLite() {
        this.tl = new TimelineLite();
    }

    _bindEvents() {
        window.addEventListener('load', () => {
            this._animateLoader();

            setTimeout(() => {
                this._animateHeader();
                this._animateContainer();
            }, this.delayAnimate);
        });
    }

    _animateHeader() {
        this.header.classList.add('is-animate');
    }

    _animateLoader() {
        this.loader.classList.add('is-animate');

        this.tl.to(this.loader, this.durationAnimate, {
            top       : `${this.header.offsetHeight}px`,
            delay     : this.delayAnimate / 1000,
            onComplete: () => {
                this.header.classList.remove('b-header-wrap_with_animate');
                this.header.classList.remove('is-animate');
            }
        });
    }

    _animateContainer() {
        const heightChild = this.container.querySelector('.container');
        const paddingTop = window.getComputedStyle(this.container, null).getPropertyValue('padding-top');
        const height = parseInt(heightChild.offsetHeight, 10) + parseInt(paddingTop, 10);

        this.tl.to(this.container, this.durationAnimate, {
            height,
            onComplete: () => {
                this.container.classList.remove('start-section_with_animate');
                this.container.removeAttribute('style');
                this.mainObject.classList.remove('main-object_with_animate');
            }
        });
    }
}

export default StartSection;
